import React from 'react';
import Slider from 'react-infinite-logo-slider';
import _ from 'lodash';
import useMediaQuery from '../../hooks/useMediaQuery';

const validators = [
    {name: 'crypto.com', logo: 'CryptoDotCom.png'},
    {name: 'Binance', logo: 'Binance.png'},
    {name: 'Google', logo: 'Google.png'},
    {name: 'Blockchain.com', logo: 'BlockchainDotCom.png'},
    {name: 'Samsung', logo: 'Samsung.png'},
    {name: 'Sony', logo: 'Sony.png'},
    {name: 'CAA', logo: 'CAA.png'},
    {name: 'FuelFoundry', logo: 'Fuelfoundry.png'},
    {name: 'gumi', logo: 'Gumi.png'},
    {name: 'DHVC', logo: 'DHVC.png'},
    {name: 'Deutsche Telekom', logo: 'Deutsche Telekom.png'},
    {name: 'NTT Digital', logo: 'NTT Digital.png'},
    {name: 'Olympique Marseille', logo: 'Olympique Marseille.png'},
];

const ValidatorPartnersSection = () => {
    const isMobile = useMediaQuery(768);
    const windowWidth = window.innerWidth;

    return (
        <div className={'ValidatorPartnersSection'}>
            <h2 className={'ValidatorPartnersSection__title'}>
                Theta Validator Partners
            </h2>
            <p className={'ValidatorPartnersSection__subtitle'}>
                Secured by global enterprise leaders
            </p>
            <div className={'ValidatorPartnersSection__slider'}>
                <Slider
                    width={isMobile ? '100px' : '130px'}
                    duration={((validators.length * 12) * (Math.min(windowWidth, 1366) / 1366))}
                    pauseOnHover={true}
                    blurBorders={false}
                    blurBorderColor={'#fff'}
                >
                    {
                        _.map(validators, (validator, idx) => (
                            <Slider.Slide key={idx}>
                                <div className={'ValidatorPartnersSection__logo-item'}>
                                    <img
                                        src={`/images/logos/validators/${validator.logo}`}
                                        alt={validator.name}
                                    />
                                </div>
                            </Slider.Slide>
                        ))
                    }
                </Slider>
            </div>
        </div>
    );
};

export default ValidatorPartnersSection;
